import { render } from "./FavouriteLawyers.vue?vue&type=template&id=d5e6ab80"
import script from "./FavouriteLawyers.vue?vue&type=script&lang=js"
export * from "./FavouriteLawyers.vue?vue&type=script&lang=js"

import "./FavouriteLawyers.vue?vue&type=style&index=0&id=d5e6ab80&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__